import { IDefaultMessages } from './types/defaultMessages';
const DefaultMessages: IDefaultMessages = {
    sizeError: 'ERROR_MESSAGE_FILE_SIZE',
    extensionError: 'ERROR_MESSAGE_FILE_EXTENSION',
    extensionErrorSingular: 'ERROR_MESSAGE_FILE_EXTENSION_SINGULAR',
    dimensionError: 'ERROR_MESSAGE_FILE_DIMENSION',
};

export default DefaultMessages;
